/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.9.0",
  "gitBuildTime": "2026-09-15T15:33:31.945Z",
  "gitBuildVersion": "2.9.0",
  "gitCommitId": "94c6059",
  "gitCommitIdFull": "94c6059912ffd55083c572fc51c00241c320136e",
  "gitCommitTime": "2026-09-15T15:28:37.000Z",
  "version": "2.9.0-2026-09-15T15:28:37.000Z-(94c6059)"
};
